import { useMutation, type MutationHookOptions } from "@apollo/client";
import CreateOrganizationUserMutation from "../graphql/mutations/CreateOrganizationUserMutation.graphql";
import DeleteOrganizationUsersMutation from "../graphql/mutations/DeleteOrganizationUsersMutation.graphql";
import RestoreOrganizationUsersMutation from "../graphql/mutations/RestoreOrganizationUsersMutation.graphql";
import UpdateOrganizationUserRolesMutation from "../graphql/mutations/UpdateOrganizationUserRolesMutation.graphql";
import type {
  UpdateOrganizationUserRolesMutationType,
  UpdateOrganizationUserRolesMutationVariablesType,
} from "@/types/graphql/admin.generated";

/**
 * Хуки для мутаций organizationUsers
 * Базовая entity-логика без UI-специфики
 */

export function useCreateOrganizationUserMutation() {
  return useMutation(CreateOrganizationUserMutation);
}

export function useDeleteOrganizationUsersMutation() {
  return useMutation(DeleteOrganizationUsersMutation);
}

export function useRestoreOrganizationUsersMutation() {
  return useMutation(RestoreOrganizationUsersMutation);
}

export function useUpdateOrganizationUserRolesMutation(
  options?: MutationHookOptions<
    UpdateOrganizationUserRolesMutationType,
    UpdateOrganizationUserRolesMutationVariablesType
  >
) {
  return useMutation<
    UpdateOrganizationUserRolesMutationType,
    UpdateOrganizationUserRolesMutationVariablesType
  >(UpdateOrganizationUserRolesMutation, options);
}
